export default "__VITE_ASSET__OcgLVvE7__"